var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.924 18.475a1.8 1.8 0 0 1-2.547 0l-3.853-3.85a1.8 1.8 0 0 1 0-2.548l6.498-6.494a2.001 2.001 0 0 1 1.414-.586h3.565a2 2 0 0 1 2 2v3.56c0 .531-.21 1.04-.584 1.415z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.003 7.999v3.798a2 2 0 0 1-.587 1.415l-5.664 5.665"
  }))));
};
export { SvgTag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMjVlOTE4YzdhNmVmMWQwMmNlNDUxZjUwMGY0YTUyYmUuc3ZnIjs=";